import { Box, useMediaQuery, useTheme } from '@mui/material';
import Grid from '@mui/material/Grid';
import DiagramaC42 from '../images/DiagramaC4-2.png';
import DiagramaC4 from '../images/DiagramaC4.png';
import hrDatabasesImg from '../images/hr-databases.png';
import operationImg from '../images/operational-data.png';
import otherSourceImg from '../images/other-source.png';
import systemImg from '../images/system-control.png';
import '../styles/Page3.css';

export function Page3() {
    const theme = useTheme();
    const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
    const diagramResponsive = isMdUp ? DiagramaC4 : DiagramaC42;
    return (
        <Box mt={5} sx={{ flexGrow: 1, minHeight: '100vh' }} >
            <Grid container spacing={1}>
                <Grid size={{ xs: 12, md: 12 }} className="img-grid">
                    <fieldset className="diagram-grid">
                        <legend className='diagram-legend'>Diagrama C4</legend>
                        <img src={diagramResponsive} alt='Diagrama C4' className='img-diagram' />
                        <div className="legend-bottom">Data sources</div>
                    </fieldset>
                </Grid>

                <Grid size={12}>
                    <Grid container spacing={7} className='grid-source'>

                        <Grid size={{ xs: 12, md: 3 }} className='source-block' >
                            <Grid container spacing={0} >
                                <Grid size={{ xs: 12, md: 12 }} >
                                    <h1 className='system-sub'>Ops Control Systems</h1>
                                </Grid>
                                <Grid size={{ xs: 6, md: 12 }} className='grid-icon'>
                                    <img src={systemImg} alt='diagram' className='system-icon' />
                                </Grid>
                                <Grid size={{ xs: 6, md: 12 }}>
                                    <ul className='list'>
                                        <li>Rotations status</li>
                                        <li>Operational times (planned/actual)</li>
                                        <li>Delays</li>
                                        <li>Crewmember status</li>
                                        <li>Aircraft information</li>
                                        <li>Flight Itinerary</li>
                                    </ul>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12, md: 3 }} className='source-block'>
                            <Grid container spacing={0} >
                                <Grid size={{ xs: 12, md: 12 }}>
                                    <h1 className='system-sub'>Operational data</h1>
                                </Grid>
                                <Grid size={{ xs: 6, md: 12 }} className='grid-icon'>
                                    <img src={operationImg} alt='operation' className='operation-icon' />
                                </Grid>
                                <Grid size={{ xs: 6, md: 12 }}>
                                    <ul className='list'>
                                        <li>Weight and balance data</li>
                                        <li>Passengers</li>
                                        <li>Cargo</li>
                                        <li>Slots</li>
                                        <li>Flight plans</li>
                                        <li>Airport Operations</li>
                                    </ul>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12, md: 3 }} className='source-block'>
                            <Grid container spacing={0}>
                                <Grid size={{ xs: 12, md: 12 }} >
                                    <h1 className='system-sub'>HR Databases</h1>
                                </Grid>
                                <Grid size={{ xs: 6, md: 12 }} className='grid-icon'>
                                    <img src={hrDatabasesImg} alt='hr-database' className='hr-icon' />
                                </Grid>
                                <Grid size={{ xs: 6, md: 12 }}>
                                    <ul className='list'>
                                        <li>Employee data</li>
                                        <li>Training</li>
                                        <li>Grouping dimensions</li>
                                        <li>(Ranks, Bases, Status)</li>
                                        <li>Crew Qualifications</li>
                                        <li>Fatigue risk (a nivel KPI´s)</li>
                                    </ul>
                                </Grid>
                            </Grid>
                        </Grid>

                        <Grid size={{ xs: 12, md: 3 }} className='source-block'>
                            <Grid container spacing={0} >
                                <Grid size={{ xs: 12, md: 12 }}>
                                    <h1 className='system-sub'>Other sources</h1>
                                </Grid>
                                <Grid size={{ xs: 6, md: 12 }} className='grid-icon'>
                                    <img src={otherSourceImg} alt='other-Source' className='otherSource-icon' />
                                </Grid>
                                <Grid size={{ xs: 6, md: 12 }}>
                                    <ul className='list'>
                                        <li>Flight execution in different stages</li>
                                        <li>Fuel KPI´s</li>
                                        <li>Maintenance Information</li>
                                        <li>Ground Handling</li>
                                        <li>Weather</li>
                                    </ul>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    );
}
